import { fetchAllSiteSettings } from '@gn-audio/core/api/site-settings/fetch-all-site-settings';
var SolutionSummaryBoxComponentController = (function () {
    function SolutionSummaryBoxComponentController($q, cartChannel) {
        this.$q = $q;
        this.cartChannel = cartChannel;
        this.prices = [];
        this.totalPrice = '';
        this.totalPriceNumber = 0;
        this.totalNonVatPrice = '';
        this.totalNonVatPriceNumber = 0;
        this.hasTotalPrice = false;
        this.ecomEnabled = false;
        if (this.currency) {
            this.recalculateTotalPrice();
        }
    }
    SolutionSummaryBoxComponentController.prototype.addToCart = function () {
        var _this = this;
        if (!this.ecomEnabled) {
            return;
        }
        if (!this.onAddToCart) {
            return;
        }
        var addedItems = [];
        addedItems.push({
            price: (this.prices.filter(function (x) { return x.groupId === _this.group.groupId; })[0] ||
                {}).price,
            sku: this.group.sku,
        });
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var items = _a[_i];
            var _loop_1 = function (item) {
                addedItems.push({
                    price: (this_1.prices.filter(function (x) { return x.groupId === item.groupId; })[0] ||
                        {}).price,
                    sku: item.sku,
                });
            };
            var this_1 = this;
            for (var _b = 0, items_1 = items; _b < items_1.length; _b++) {
                var item = items_1[_b];
                _loop_1(item);
            }
        }
        this.onAddToCart({ items: addedItems });
    };
    SolutionSummaryBoxComponentController.prototype.$onInit = function () {
        var _this = this;
        if (!Array.isArray(this.items)) {
            this.items = [];
        }
        this.$q.when(fetchAllSiteSettings())
            .then(function (settings) {
            _this.priceDisplayOption = settings.priceDisplayOption;
            _this.priceDisplayThreshold = settings.priceDisplayThreshold;
            _this.ecomEnabled = settings.ecomEnabled;
            _this.currency = _this.currency || settings.currency;
            if (_this.currency) {
                _this.recalculateTotalPrice();
            }
        })
            .finally(function () {
            _this.cartChannel.init(_this.items);
        });
    };
    SolutionSummaryBoxComponentController.prototype.remove = function (items) {
        var index = this.items.indexOf(items);
        if (index > -1) {
            for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
                var item = items_2[_i];
                for (var j = this.prices.length - 1; j > -1; j--) {
                    if (item.groupId === this.prices[j].groupId) {
                        this.prices.splice(j, 1);
                    }
                }
            }
            this.items.splice(index, 1);
            this.cartChannel.remove(items);
        }
        this.recalculateTotalPrice();
    };
    SolutionSummaryBoxComponentController.prototype.onPriceLoaded = function (price) {
        if (!price) {
            return;
        }
        this.currency = price.currency;
        this.prices.push({ groupId: price.groupId, price: price });
        this.recalculateTotalPrice();
    };
    SolutionSummaryBoxComponentController.prototype.showNonVatPrice = function () {
        return ((this.priceDisplayOption === "ExcludeVATThreshold" &&
            (this.group.segmentType === "Business" ||
                this.totalNonVatPriceNumber < this.priceDisplayThreshold)) ||
            (this.priceDisplayOption === "ExcludeIncludeVAT" &&
                this.group.segmentType === "Business"));
    };
    SolutionSummaryBoxComponentController.prototype.recalculateTotalPrice = function () {
        var totalPrice = this.prices.reduce(function (accumulator, y) {
            return accumulator + y.price.fromDiscountedPrice;
        }, 0);
        var totalNonVatPrice = this.prices.reduce(function (accumulator, y) {
            return accumulator + y.price.fromDiscountedPriceWithoutVat;
        }, 0);
        if (!this.currency && this.prices.length > 0) {
            this.currency = this.prices[0].price.currency;
        }
        this.hasTotalPrice = totalPrice > 0 || totalNonVatPrice > 0;
        if (this.currency) {
            this.totalPrice = totalPrice.toLocaleString(this.marketLocale, {
                currency: this.currency,
                style: 'currency',
            });
            this.totalPriceNumber = totalPrice;
            this.totalNonVatPrice = totalNonVatPrice.toLocaleString(this.marketLocale, {
                currency: this.currency,
                style: 'currency',
            });
            this.totalNonVatPriceNumber = totalNonVatPrice;
            if ((this.marketLocale || '').toLocaleLowerCase() === 'en-ca') {
                this.totalPrice = "CDN" + this.totalPrice;
                this.totalNonVatPrice = "CDN" + this.totalNonVatPrice;
            }
        }
    };
    SolutionSummaryBoxComponentController.$inject = ['$q', 'cartChannel'];
    return SolutionSummaryBoxComponentController;
}());
export { SolutionSummaryBoxComponentController };
export var SolutionSummaryBoxComponent = {
    bindings: {
        group: '<',
        items: '<?',
        onAddToCart: '&?',
        thirdPartyDevices: '<',
    },
    controller: SolutionSummaryBoxComponentController,
    templateUrl: 'compatibilityguide/ng-templates/feature/summarybox/solutionsummarybox',
};
